import React from 'react';
import './Spinner.css';

export default () => {
  return (
    <div className='spinner-container'>
      <img src='img/spinner.png' alt='Loading Spinner'/> 
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/Components/Spinner.js